import React from 'react';
import _ from 'underscore';
import {connect} from 'react-redux';
import { useParams } from 'react-router-dom';
import AuctionsList from '../components/AuctionsList/AuctionsList';
import AuctionFilter from './AuctionFilter';
import {
    prepareFilteredAuctions,
    prefetchAuctionsPage,
    setLastListUrl
} from '../ducks';
import {
    getTransform,
    OBJECT_AUCTION,
    OBJECT_CATEGORY
} from '../utils/sources';
import {getFilterParamsFromMatch} from '../utils/auctions';
import {
    getAuctionListFullUrl,
    getPastAuctionListFullUrl
} from '../utils/urls';

const ConnectedAuctionsList = connect(
    (state, {match, past}) => {
        const transformAuction = getTransform(OBJECT_AUCTION);
        const transformCategory = getTransform(OBJECT_CATEGORY);
        const {category, region, date} = getFilterParamsFromMatch(match, state.lockCategory);
        let categoryData;

        if (category) {
            categoryData = _(state.categories.data)
                .chain()
                .map(transformCategory)
                .find(({value}) => value === category)
                .value();
        }

        // Handle both new normalized structure and legacy array format
        const auctionsData = state.auctions.data;
        let auctionItems = [];
        let totalPages = null;
        let totalItems = null;

        if (auctionsData) {
            if (auctionsData.items) {
                // New normalized structure: { items: [...], totalPages, totalItems }
                auctionItems = auctionsData.items;
                totalPages = auctionsData.totalPages;
                totalItems = auctionsData.totalItems;
            } else if (Array.isArray(auctionsData)) {
                // Legacy: plain array
                auctionItems = auctionsData;
            }
        }

        return {
            auctions: _(auctionItems).map(transformAuction),
            auctionsLoading: state.auctions.loading,
            auctionsPerPage: state.auctionsPerPage,
            filterRegion: region,
            filterCategory: category,
            filterDate: date,
            Filter: AuctionFilter,
            categoryName: (categoryData || {}).display,
            getUrl: past ? getPastAuctionListFullUrl : getAuctionListFullUrl,
            lockCategory: state.lockCategory,
            premiumFilter: state.premiumFilter,
            totalPages: totalPages,
            totalItems: totalItems,
        };
    },
    (dispatch, {match, past}) => ({
        loadData: (lockCategory) => {
            let {page, category, region, date} = getFilterParamsFromMatch(match, lockCategory);

            dispatch(prepareFilteredAuctions(page, category, region, date, past));
            const getUrl = past ? getPastAuctionListFullUrl : getAuctionListFullUrl;
            dispatch(setLastListUrl(getUrl(page, category, region, date)));
        },
        prefetchPage: (page, category, region, date, past) => {
            dispatch(prefetchAuctionsPage(page, category, region, date, past));
        }
    }),
    (stateProps, dispatchProps, ownProps) => ({
        ...ownProps,
        ...dispatchProps,
        ...stateProps,
        loadData: () => dispatchProps.loadData(stateProps.lockCategory),
    })
)(AuctionsList);

// Wrapper component that extracts route params and creates match object
function AuctionsListContainer(props) {
    const params = useParams();
    const match = { params };
    return React.createElement(ConnectedAuctionsList, Object.assign({}, props, { match: match }));
}

export default AuctionsListContainer;
